export class AuditTrailModel {
  auditTrailId: number = 0;
  clientId: number = 0; 
  userId: string = "";
  pageURL: string = "";
  duration: string = "";
  ipAddress: string = "";
  isActive: boolean = true;
  isDeleted: boolean = false;
  createdOnUtc: Date = new Date();
  createdBy: string = "";
  updatedOnUtc: Date = new Date();
  updatedBy: string = "";
  clientCode: string = "";
  userName: string = "";
}
